/* =============================================================================
File: EasyStumpOut_Footer_v01.tsx
Description: ReactSetv22026BSSC footer component for EasyStumpOut.
Version: v01
Date: 2026-04-14
============================================================================= */

import React from "react";
import { Container } from "react-bootstrap";
import { Link, useLocation } from "react-router-dom";
import type { ILocationConfig } from "../App_CONFIG_v01a";

function EasyStumpOut_Footer_v01({
  locationConfig,
}: {
  locationConfig: ILocationConfig;
}) {
  const year = new Date().getFullYear();
  const location = useLocation();
  const isHome = location.pathname === "/";

  return (
    
        <footer className="py-4">
          <Container>
            <div className="d-flex align-items-center flex-wrap">

              {/* LEFT */}
              <div>
                <a href="/" className="text-decoration-none">
                  <div>
                    {/* <div className="fw-bold">{locationConfig.websiteName}</div> */}

                    <div className="fw-bold">
                       {locationConfig.logoPart1}
                       <span style={{ color: "text-primary" }}>{locationConfig.logoPart2}</span>
                       {locationConfig.logoPart3}{" "}&nbsp;&nbsp;
                    </div>

                    <div className="small">
                      Stump Grinding • Surface Roots • Debris Haul-Off
                    </div>
                  </div>
                </a>
              </div>

              {/* CENTER (TRUE CENTER) */}
              <div className="mx-auto small text-center">
                <Link to="/tos" className="text-decoration-none">
                  Terms of Service
                </Link>
                <span className="mx-2">•</span>
                <Link to="/privacy" className="text-decoration-none">
                  Privacy Policy
                </Link>
              </div>

              {/* RIGHT */}
              <div className="small ms-auto text-end">
                {locationConfig.webSiteVersion}
              </div>

            </div>

            <hr className="border-light opacity-25 my-3" />

            <div className="small">
              © {year} {locationConfig.websiteName} All rights reserved.
            </div>
          </Container>
        </footer>


  );
}

export default EasyStumpOut_Footer_v01;

/* =============================================================================
File: EasyStumpOut_Footer_v01.tsx
Description: Footer component for EasyStumpOut using ReactSetv22026BSSC structure.
Version: v01
Date: 2026-04-14
============================================================================= */
